import { render, staticRenderFns } from "./PurchaseMultiConnectCreditsDialog.vue?vue&type=template&id=36b3077a"
import script from "./PurchaseMultiConnectCreditsDialog.vue?vue&type=script&lang=js"
export * from "./PurchaseMultiConnectCreditsDialog.vue?vue&type=script&lang=js"
import style0 from "./PurchaseMultiConnectCreditsDialog.vue?vue&type=style&index=0&id=36b3077a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports